import * as olProj from 'ol10/proj';
import Projection from 'ol10/proj/Projection';

/**
 * 注册 GCJ02 投影
 */
export function registerGCJ02 () {
  let gcjMecator = olProj.get('GCJ-02');
  if (!gcjMecator) {
    const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244];
    gcjMecator = new Projection({ code: 'GCJ-02', extent: gcj02Extent, units: 'm' });
    olProj.addProjection(gcjMecator);
    if (window.projzh) {
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll);
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc);
    }
  }
  return gcjMecator;
}

/**
 * 获取必应/星图地图瓦片URL
 */
export function getSpecialTileUrl (z, x, y, url, urlEnd, name) {
  let quadKey = '';
  if (name === '必应地图') {
    let tileX = x;
    let tileY = y;
    for (let i = 0; i < z; i++) {
      quadKey = ((tileX & 1) + 2 * (tileY & 1)).toString() + quadKey;
      tileX >>= 1;
      tileY >>= 1;
    }
  } else if (name === '星图地图') {
    quadKey = z + '/' + x + '/' + y;
  }
  return url + quadKey + urlEnd;
}
